//Reference
//http://www.statoids.com/uza.html
//ISO: Province codes from ISO 3166-2. For full identification in a global context, prefix "ZA-" to the code
//HASC - Hierarchical administrative subdivision codes.
//Conv - Conventional abbreviations used popularly (sometimes L for Limpopo).

import { IDropDownOptions } from "../../../Component/Common/Components/FormValidationInputs/AppSelectList";
import { StaticDataModel } from "../../../Component/Model/Dto/StaticData";

//Order of codes:
//ISO
//HASC
//NAME
//BEE123 ProvinceTypes ID
//Conv
export const ProvinceLookupTable = [
    ['Unspecified', 'Unspecified', 'Unspecified', 0, 'Unspecified'],
    ['ZA-NAT', 'ZA-NAT', 'National', 1, 'NAT'],
    ['ZA-EC', 'ZA-EC', 'Eastern Cape', 2, 'EC'],
    ['ZA-FS', 'ZA-FS', 'Free State', 3, 'FS'],
    ['ZA-GT', 'ZA-GT', 'Gauteng', 4, 'GP'],
    ['ZA-NL', 'ZA-NL', 'KwaZulu-Natal', 5, 'KZN'],
    ['ZA-LP', 'ZA-NP', 'Limpopo', 6, 'LP'],
    ['ZA-MP', 'ZA-MP', 'Mpumalanga', 7, 'MP'],
    ['ZA-NC', 'ZA-NC', 'Northern Cape', 9, 'NC'],
    ['ZA-NW', 'ZA-NW', 'North-West', 8, 'NW'],
    ['ZA-WC', 'ZA-WC', 'Western Cape', 10, 'WC'],
];

export enum ProvinceCode {
    ISO,
    HASC,
    Name,
    ProvinceTypesEnumId,
    Conv
}

export const provinceLookupVal = (lookupValue: string, sourceCode: ProvinceCode, destCode: ProvinceCode) => {
    let item = ProvinceLookupTable.find(x => x[sourceCode].toString().toLowerCase() === lookupValue.toString().toLowerCase());
    switch (destCode) {
        case ProvinceCode.ISO:
            return (item && item[destCode]) || '';
        case ProvinceCode.HASC:
            return (item && item[destCode]) || '';
        case ProvinceCode.Name:
            return (item && item[destCode]) || 'Unspecified';
        case ProvinceCode.ProvinceTypesEnumId:
            return (item && item[destCode]) || 0 /*Unspecified*/;
        default:
            return null;
    }
}

export const getProvinceLookup = () => {
    const ids: number[] = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10];
    const provinceLookupData: IDropDownOptions[] = [];

    ids.forEach(element => {
        const lookupValue: IDropDownOptions = { id: element, value: provinceLookupVal(element.toString(), ProvinceCode.ProvinceTypesEnumId, ProvinceCode.Name) as string }
        provinceLookupData.push(lookupValue);
    });
    return provinceLookupData;
}

export const getProvinceModelById = (id: number): StaticDataModel => {
    const lookupId = provinceLookupVal(id.toString(), ProvinceCode.ProvinceTypesEnumId, ProvinceCode.ProvinceTypesEnumId) as number;
    const lookupName = provinceLookupVal(id.toString(), ProvinceCode.ProvinceTypesEnumId, ProvinceCode.Name) as string;
    return { Id: lookupId, Name: lookupName }
}
